module.exports = __webpack_public_path__ + "static/media/france-3.b3313fa4.png";